// extracted by mini-css-extract-plugin
export default {"tabs":"p1-z","tablist":"q1-z","tablistItem":"r1-z"};